import { render, staticRenderFns } from "./ShippingCompaniesByDxkTime.vue?vue&type=template&id=11162e47&"
import script from "./ShippingCompaniesByDxkTime.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompaniesByDxkTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports